import Swal from "sweetalert2";
import store from "@/store";
export function toast(text) {
  Swal.fire({
    position: "center",
    icon: "success",
    title: text,
    showConfirmButton: false,
    background: "#EAEAEA",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
    allowOutsideClick: false,
    timer: 2500,
  }).then(() => {
    store.dispatch("setLoading", false);
  });
}

export function toastError(text) {
  Swal.fire({
    position: "center",
    icon: "error",
    title: text,
    showConfirmButton: false,
    showCloseButton: true,
    background: "#EAEAEA",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
    allowOutsideClick: false,
  }).then(() => {
    store.dispatch("setLoading", false);
  });
}
